import { useEffect, useRef } from 'react';

import { guid } from 'helpers/guid';

// This hook creates a static guid after the first render (to prevent server- and client-side id value mismatches.)
const useClientGuid = () => {
  const uniqueID = useRef();
  useEffect(() => {
    uniqueID.current = guid();
  }, []);
  return uniqueID.current;
};

export default useClientGuid;
